import { Box, TextField } from '@mui/material';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import { isValid } from 'date-fns';
import React from 'react';
import { Control, useController } from 'react-hook-form';
import { dateTimeFieldFormat, is24HourClock } from '../../utils/formatTime';

export type StartTimeFieldProps = Partial<DateTimePickerProps<Date, Date>> & {
  control: Control<any>;
  disabled?: boolean;
  name: string;
};

const StartTimeField = ({ control, disabled, name }: StartTimeFieldProps) => {
  const {
    field,
    fieldState: { error },
    formState,
  } = useController({
    control,
    name,
    rules: {
      required: 'Please provide a start time',
      validate: {
        date: v => isValid(v) || 'This is no valid date',
      },
    },
  });

  return (
    <Box
      component={DateTimePicker}
      {...field}
      disabled={disabled}
      disableMaskedInput
      ampm={!is24HourClock}
      inputFormat={dateTimeFieldFormat}
      label="From date and time"
      renderInput={props => (
        <TextField
          {...props}
          error={!disabled && (!!error || !!formState.errors.timeRange)}
          helperText={!disabled && (error?.message ?? (formState.errors.timeRange?.message as string))}
          required
        />
      )}
      sx={{ flex: 1 }}
    />
  );
};

export default StartTimeField;
